import { InjectionToken } from '@angular/core';

export const FALLBACK_LANGUAGE = new InjectionToken('FALLBACK_LANGUAGE');
export const PATH_TRANSLATIONS = new InjectionToken('PATH_TRANSLATIONS');
export const ADD_TRANSLATIONS = new InjectionToken('ADD_TRANSLATIONS');
